<template>
    <div>
        <section
            class="section is-hidden-tablet px-0 py-0 has-background-pale-grey"
        ></section>
        <section ref="contentBox" class="section">
            <dashboard-folders
                v-if="selectedFilter == 'mine'"
                @addProject="addProjectToFolder"
            />
            <explorer-folder-section
                v-if="selectedFilter === 'mySchool' && featuredProjects.length"
                :projects="featuredProjects"
                :expanded="true"
                :class="searchString ? 'hide' : 'show'"
                name="Destacados"
                class="pl-3"
                @click="selectProject($event)"
            />
            <hr v-if="selectedFilter == 'mine'" />
            <app-search-bar-with-filter
                v-if="selectedFilter != 'invited'"
                v-model="searchString"
                :filter.sync="selectedType"
                class="pt-6"
            />
            <div
                v-if="
                    !searchString &&
                    selectedFilter === 'mySchool' &&
                    featuredProjects.length
                "
                class="section px-0 pt-0 pl-3"
            >
                <div class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <h1 class="title has-text-weight-bold is-size-5">
                                {{ $t('Dashboard.my_school_projects') }} ({{
                                    projects.length
                                }})
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <project-search-bar-with-filter
                v-if="selectedFilter == 'invited'"
                v-model="searchString"
                :filter.sync="selectedProjectOption"
                class
            />
            <div
                v-if="
                    selectedFilter === 'mine' &&
                    !projects.length &&
                    !this.searchString
                "
                class="section py-0"
            >
                <div class="columns is-multiline is-mobile mx-0">
                    <router-link
                        :key="'creationCard'"
                        class="
                            column
                            is-12-mobile is-6-tablet is-4-desktop is-3-fullhd
                            lb-project-card lb-creation-object
                        "
                        :to="'/creation'"
                    >
                        <div class="lb-project-box has-background-info-light">
                            <div
                                class="
                                    columns
                                    is-multiline is-mobile is-marginless
                                    has-background-info-light
                                "
                            >
                                <div
                                    class="
                                        column
                                        is-full
                                        has-text-centered
                                        has-text-weight-bold
                                        has-text-primary
                                    "
                                >
                                    <span class="icon is-large">
                                        <i
                                            class="
                                                mdi
                                                mdi-10r
                                                mdi-plus-circle-outline
                                                pt-5
                                            "
                                            aria-hidden="true"
                                        />
                                    </span>
                                </div>
                                <div
                                    class="
                                        column
                                        is-full
                                        has-text-centered has-text-weight-bold
                                    "
                                >
                                    <p
                                        class="
                                            is-size-5
                                            lb-card-title
                                            is-block
                                            has-text-primary
                                        "
                                    >
                                        {{ $t('creation.first_project') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            <dashboard-content
                v-else
                ref="childComponent"
                :active-filter="selectedFilter"
                :items="projects"
                :loading="loadingItems"
                @delete="removeProject"
            />
        </section>
    </div>
</template>

<script>
import AppSearchBarWithFilter from '@/components/AppSearchBarWithFilter';
import DashboardContent from '@/components/DashboardContent';
import ExplorerFolderSection from '@/components/ExplorerFolderSection';
import DashboardFolders from '@/components/DashboardFolders';
import _ from 'underscore';
import { fetchItems, addProjectToFolder } from '@/services/API';
import ProjectSearchBarWithFilter from '@/components/ProjectSearchBarWithFilter';
export default {
    components: {
        AppSearchBarWithFilter,
        DashboardContent,
        ExplorerFolderSection,
        DashboardFolders,
        ProjectSearchBarWithFilter,
    },
    data() {
        return {
            loadingItems: false,
            searchString: this.$route.query.search,
            selectedType: 'FILTER_OPTION_PROJECTS_ALL',
            selectedFilter: this.$route.query.filter || 'mine',
            queryType: this.$route.query.type,
            items: [],
            projects: [],
            featuredProjects: [],
            currentPage: 1,
            limit: 24,
            offset: 0,
            lastPage: false,
            //availableProjectOptions: [this.$t('Constants.FILTER_OPTION_ALL'),this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'),this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED')],
            selectedProjectOption: this.$t('Constants.FILTER_OPTION_ALL'),
        };
    },
    computed: {
        projectType() {
            if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS')
            ) {
                return 'collection';
            } else if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES')
            ) {
                return 'trivial,treasurehunt';
            }
            return 'collection,trivial,treasurehunt,storytelling';
        },
        handleDebouncedScroll() {
            return _.debounce(this.handleScroll, 100);
        },
    },
    watch: {
        '$route.query.filter': function (newValue) {
            if (newValue) {
                this.selectedFilter = newValue;
            }
        },
        '$route.query.type': function (newValue) {
            this.queryType = newValue;
        },
        '$route.query.search': function (newValue) {
            this.searchString = newValue;
        },
        selectedFilter: {
            handler: 'filterHandler',
            immediate: true,
        },
        searchString: {
            handler: 'searchStringHandler',
            immediate: false,
        },
        selectedType: {
            handler: 'typeHandler',
            immediate: false,
        },
        selectedProjectOption: {
            handler: 'projectOptionHandler',
            immediate: true,
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleDebouncedScroll, true);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleDebouncedScroll);
    },
    methods: {
        selectProject(project) {
            this.$refs.childComponent.selectProject(project);
        },
        async getItems() {
            if (this.loadingItems) {
                // another call is running
                return;
            }
            this.loadingItems = true;
            console.log('offset send', this.offset);
            if (!this.searchString && this.selectedFilter == 'mySchool') {
                let responseFeatured = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        type_in: this.projectType,
                        _offset: 0,
                        _limit: 9999,
                        _featured: true,
                        _sort: 'order:asc',
                    }
                );
                this.featuredProjects = responseFeatured.data;
                let response = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        title_contains: this.searchString,
                        description_contains: this.searchString,
                        owner_contains: this.searchString,
                        type_in: this.projectType,
                        _offset: this.offset,
                        _limit: this.limit,
                    }
                ).finally(() => {
                    this.loadingItems = false;
                    this.$emit('enableLinks');
                });
                console.log('items length before news', this.items.length);
                this.items = this.items.concat(response.data);
                this.offset = this.items.length;
                console.log('new offset to send ', this.offset);
                if (response.data.length < this.limit) {
                    this.lastPage = true;
                }
                this.projects = this.items.filter((item) => {
                    if (!item.featured) {
                        return item;
                    }
                });
            } else {
                let response = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        title_contains: this.searchString,
                        description_contains: this.searchString,
                        owner_contains: this.searchString,
                        type_in: this.projectType,
                        _offset: this.offset,
                        _limit: this.limit,
                    }
                ).finally(() => {
                    this.loadingItems = false;
                    this.$emit('enableLinks');
                });
                this.items = this.items.concat(response.data);
                this.offset = this.items.length;
                if (response.data.length < this.limit) {
                    this.lastPage = true;
                }
                this.projects = this.items;
                if (
                    this.selectedProjectOption !=
                        this.$t('Constants.FILTER_OPTION_ALL') &&
                    this.selectedFilter == 'invited'
                ) {
                    this.projectOptionHandler();
                }
            }
        },
        async removeProject(_id) {
            console.log('removing item', _id);
            this.items = _.filter(this.items, (item) => {
                return item._id != _id;
            });
            if (this.projects.length > 0) {
                this.projects = _.filter(this.projects, (project) => {
                    return project._id != _id;
                });
            }
        },
        addProjectToFolder(project, folder) {
            let projectIndex = _.findIndex(this.projects, {
                _id: project,
            });
            const splicedProject = this.projects.splice(projectIndex, 1);
            addProjectToFolder(folder._id, { project }).catch(() => {
                this.projects.splice(projectIndex, 0, splicedProject[0]);
            });
        },
        filterHandler() {
            this.projects = [];
            this.items = [];
            this.offset = 0;
            this.lastPage = false;
            this.$emit('disableLinks');
            //this.items=[];
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ filter: this.selectedFilter } },
                })
                .catch((e) => {
                    console.log('error selected filter');
                });
            this.resetSearch();
        },
        typeHandler() {
            let query = Object.assign({}, this.$route.query);
            console.log('here', query);
            this.$router
                .push({
                    query: { ...query, ...{ type: this.projectType } },
                })
                .catch((e) => {
                    console.log('error selected tpye', e);
                });
            this.resetSearch();
        },
        searchStringHandler() {
            if (this.searchString && this.searchString.length == 0) {
                this.searchString = undefined;
            }
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ search: this.searchString } },
                })
                .catch(() => {
                    console.log('error selected string');
                });
            this.resetSearch();
        },
        resetSearch() {
            this.offset = 0;
            this.lastPage = false;
            this.items = [];
            this.getItems();
        },
        handleScroll() {
            const { scrollHeight, clientHeight, scrollTop } =
                document.documentElement;
            const bottomOfWindow =
                (scrollHeight - 300 >= clientHeight + scrollTop) /
                    scrollHeight ==
                0;
            if (bottomOfWindow && !this.lastPage) {
                this.getItems();
            }
        },
        projectOptionHandler() {
            switch (this.selectedProjectOption) {
                case this.$t('Constants.FILTER_OPTION_ALL'):
                    this.projects = this.items;
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED'):
                    this.projects = this.items.filter((item) => {
                        if (item.watching === true) {
                            return item;
                        }
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'):
                    this.projects = this.items.filter((item) => {
                        if (item.watching === false) {
                            return item;
                        }
                    });
                    break;
            }
        },
    },
};
</script>

<style scoped>
.hide {
    visibility: hidden !important;
    height: 0px;
    width: 0px;
    overflow: hidden;
}
.show {
    height: auto;
    overflow: hidden;
}
.is-horizontally-centered {
    margin: 0 auto;
}
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}
</style>
